import React from "react";
import errorImg from "../../images/error-page-image.jpg";

const PageNotFound = () => (
  <div className="error-page">
    <img src={errorImg} className="img-fluid" alt="" />
  </div>
);

export default PageNotFound;
